import React, { useState } from 'react'

import { ValidatorForm } from 'react-material-ui-form-validator'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import {
    GridContainer,
    GridItem1,
    GridItem3,
} from '../../../business-components/Grid/Grid'

import { 
    TextFieldTextSelect,
} from '../../../business-components/TextField/TextFieldSelect'

//import {
//    RichTextEditor
//} from '../../../business-components/RichTextEditor/RichTextEditor'

import {
    RichTextEditorPadrao
} from '../../../business-components/RichTextEditor/RichTextEditorPadrao'

import {
    ButtonCopiar,
} from '../../../business-components/Button/Button'

import {
    pesquisaList,
    pesquisaDescricaoList,
} from '../../../business-rules/List/ListService'

import tipoGestaoPatrimonialList from '../../../business-rules/List/tipoGestaoPatrimonialList'

import {
    CardGridEstudoPadrao,
} from '../estudo-form/EstudoComp'



const GestaoPatrimonialFormEstrategiasPlanejamento = ( { values, handleChange, handleSubmit, setFieldValue, jsonGestaoPatrimonial, title,
    idTipoGestaoPatrimonial } ) => {

    const [descricaoTipoGestaoPatrimonial, setDescricaoTipoGestaoPatrimonial] = useState('')
    const [estrategiasPlanejamento, setEstrategiasPlanejamento] = useState('')

    useSingleton(async () => {

        if (jsonGestaoPatrimonial && jsonGestaoPatrimonial.configuracaoGestaoPatrimonial) {

            const linhaConfiguracaoGestaoPatrimonial =
                pesquisaList(jsonGestaoPatrimonial.configuracaoGestaoPatrimonial, idTipoGestaoPatrimonial)

            if (linhaConfiguracaoGestaoPatrimonial.itemGestaoPatrimonial) {

                setDescricaoTipoGestaoPatrimonial(pesquisaDescricaoList(tipoGestaoPatrimonialList, idTipoGestaoPatrimonial))
                setEstrategiasPlanejamento(linhaConfiguracaoGestaoPatrimonial.itemGestaoPatrimonial)
            }
        }

        if (values.consideracaoFinal.length === 0) {

            values.consideracaoFinal.push({
                tituloPagina: '',
                richText: '',
            })
        }
    })

    return (
        estrategiasPlanejamento && (
            <CardGridEstudoPadrao
                label={title}
                component={
                    <ValidatorForm 
                        onSubmit={handleSubmit}
                        onError={
                            () => null
                        }
                    >
                        <GridContainer
                            className='justify-end'
                        >
                            <GridItem3>
                                <TextFieldTextSelect
                                    name={
                                        idTipoGestaoPatrimonial === HARDCODE.idTipoGestaoPatrimonialEstrategia
                                            ?
                                                "itemGestaoPatrimonialEstrategia"
                                            :
                                                "itemGestaoPatrimonialPlanejamento"
                                    }
                                    label={descricaoTipoGestaoPatrimonial}
                                    value={
                                        (
                                            idTipoGestaoPatrimonial === HARDCODE.idTipoGestaoPatrimonialEstrategia
                                                ?
                                                    values.itemGestaoPatrimonialEstrategia
                                                :
                                                    values.itemGestaoPatrimonialPlanejamento
                                        ) || ''}
                                    onChange={handleChange}
                                    list={estrategiasPlanejamento}
                                />
                            </GridItem3>

                            <GridItem1
                                className='mt-2'
                            >
                                {(idTipoGestaoPatrimonial === HARDCODE.idTipoGestaoPatrimonialEstrategia
                                    ?
                                        values.itemGestaoPatrimonialEstrategia
                                    :
                                        values.itemGestaoPatrimonialPlanejamento) && (
                                            <ButtonCopiar
                                                onClick={() => {

                                                    const richText =
                                                        pesquisaList(estrategiasPlanejamento,
                                                            idTipoGestaoPatrimonial === HARDCODE.idTipoGestaoPatrimonialEstrategia
                                                                ?
                                                                    values.itemGestaoPatrimonialEstrategia
                                                                :
                                                                    values.itemGestaoPatrimonialPlanejamento
                                                        ).richText

                                                    idTipoGestaoPatrimonial === HARDCODE.idTipoGestaoPatrimonialEstrategia
                                                        ?
                                                            values.estrategia = richText
                                                        :
                                                            values.consideracaoFinal[0].richText = richText
                                                    }
                                                }
                                            />
                                )}
                            </GridItem1>
                        </GridContainer>

                        {/*
                        <RichTextEditor
                            content={
                                idTipoGestaoPatrimonial === HARDCODE.idTipoGestaoPatrimonialEstrategia
                                    ?
                                        values.estrategia
                                    :
                                        values.consideracaoFinal[0]
                                }
                            handleContentChange={(content) =>
                                setFieldValue(
                                    idTipoGestaoPatrimonial === HARDCODE.idTipoGestaoPatrimonialEstrategia
                                        ?
                                            "estrategia"
                                        :
                                            "consideracaoFinal[0]",
                                    content
                                )
                            }
                        />
                        */}
                        <RichTextEditorPadrao
                            name={idTipoGestaoPatrimonial === HARDCODE.idTipoGestaoPatrimonialEstrategia
                                ?
                                    "estrategia"
                                :
                                    "consideracaoFinal[0].richText"
                            }
                            content={idTipoGestaoPatrimonial === HARDCODE.idTipoGestaoPatrimonialEstrategia
                                ?
                                    values.estrategia
                                :
                                    values.consideracaoFinal[0].richText
                            }
                            setFieldValue={setFieldValue}
                        />
                    </ValidatorForm>
                }
                overflowX={false}
                popup={false}
            />
        )
    )
}

export default GestaoPatrimonialFormEstrategiasPlanejamento